/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Search/Content/Profiles/Content/Profile/ProfileData/ExternalProfessionalInfo/Content"
  
}) {
let personExternalProfessionalInfoValueData = fromData.useDataValue({ viewPath,
context: 'person',
path: 'external_professional_info',
})
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="normal"
 color={dtColorsNeutral700}
 data="person.external_professional_info"
 text={personExternalProfessionalInfoValueData}
/>
{children}
</React.Fragment>)
}